const state = {
    appid: [],
    loading: false,
    posts: [],
    drafts:[],
    cost: [],
    task: [],
    contentTemplate: [],
    campaigns:[],
    status: [],
    campaignId: [],
    draftId: [],
    costId:[],
    taskId: [],
    contentTemplateId: [],
    eventtasks: [],
    assignee:[],
    Kpis: [],
    marketingPlan: [],
    marketingTemplate: []
};

export default state;